export default {
  form: {
    should_save_payment_info: {
      label: 'Zapisz dane płatności dla szybszej realizacji',
    },
  },
};
